import { render, staticRenderFns } from "./DataDashboard.vue?vue&type=template&id=30cf1d6a"
import script from "./DataDashboard.vue?vue&type=script&lang=js"
export * from "./DataDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports